import MetricCard from './components/MetricCard';
import TimeSeriesChart from './components/TimeSeriesChart';
import MetricExplorerChart from './components/MetricExplorerChart';
import TopSkusTable from './components/TopSkusTable';
import DailyBreakdownTable from './components/DailyBreakdownTable';

const SPEND_SERIES = [
  { dataKey: 'spend_google', label: 'Google', color: '#f59e0b', yAxisId: 'left', format: 'currency' },
  { dataKey: 'spend_meta', label: 'Meta', color: '#3b82f6', yAxisId: 'left', format: 'currency' },
];

const PAID_SHARE_SERIES = [
  { dataKey: 'google_paid_share', label: '% sesiones Google paid', color: '#10b981', yAxisId: 'left', format: 'percent' },
];

/**
 * Panel de ecommerce: scorecards (revenue/órdenes/ROAS/inversión), revenue
 * diario con CR/ticket/sesiones al costado, top 10 productos, inversión
 * Google vs Meta y el detalle diario. `previousSummary` (opcional) es el
 * summary del período de comparación; alimenta los deltas de los scorecards.
 */
export default function EcomPanel({ data, previousSummary }) {
  const prev = previousSummary ?? {};
  const { summary = {}, daily = [], top_skus: topSkus = [] } = data;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <MetricCard label="Revenue" value={summary.revenue} format="currency"
                    previousValue={prev.revenue} better="up" />
        <MetricCard label="Órdenes" value={summary.orders} format="number"
                    previousValue={prev.orders} better="up" />
        <MetricCard label="ROAS" value={summary.roas} format="ratio"
                    previousValue={prev.roas} better="up" />
        <MetricCard label="Inversión" value={summary.spend} format="currency"
                    previousValue={prev.spend} better="neutral" />
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <MetricExplorerChart daily={daily} />
        </div>
        <div className="grid grid-cols-3 gap-3 lg:grid-cols-1">
          <MetricCard label="Tasa de conversión" value={summary.conversion_rate} format="percent"
                      previousValue={prev.conversion_rate} better="up" />
          <MetricCard label="Ticket promedio" value={summary.avg_ticket} format="currency"
                      previousValue={prev.avg_ticket} better="up" />
          <MetricCard label="Sesiones" value={summary.sessions} format="number"
                      previousValue={prev.sessions} better="up" />
        </div>
      </div>

      {topSkus.length > 0 && <TopSkusTable skus={topSkus} />}

      <TimeSeriesChart title="Inversión Google vs Meta" data={daily} series={SPEND_SERIES} />

      {daily.some((d) => d.google_paid_share != null) && (
        <TimeSeriesChart
          title="Share de sesiones Google Ads (Paid Search + Cross-network)"
          data={daily}
          series={PAID_SHARE_SERIES}
        />
      )}

      <div className="grid grid-cols-3 gap-3">
        <MetricCard label="CPC" value={summary.cpc} format="currency2"
                    previousValue={prev.cpc} better="down" />
        <MetricCard label="CTR" value={summary.ctr} format="percent"
                    previousValue={prev.ctr} better="up" />
        <MetricCard label="CPM" value={summary.cpm} format="currency2"
                    previousValue={prev.cpm} better="down" />
      </div>

      {daily.length > 0 ? (
        <DailyBreakdownTable daily={daily} />
      ) : (
        <p className="py-8 text-center text-sm text-gray-500">
          Sin datos para el rango seleccionado.
        </p>
      )}
    </div>
  );
}
